import { createStore } from 'vuex'
import Vue from 'vue'

export default createStore({
    //equivalente di data
    state: {
        db: [],
        db2:{}
    },
    //contiene i metodi delle variabili in state
    getters: {
        episodi: (state) => state.db,
        episodi2: (state) => { return state.db2  }
        
    },
    //functions per modificare i value of states,sync
    mutations: {

        caricaDb(state, datiUpdate) {
            state.db = datiUpdate.episodi
            datiUpdate.episodi.forEach(element => {
                state.db2[element.id] = element
            });
        }
    },
    //functions we call from mutations,async
    actions: {
    },
    modules: {
    }
})
